export const SourceQuarantine = "quarantines";
export const SourceQuarantineReasonList = "quarantinereasons";
export const SourceQuarantineDetailList = "quarantinedetails";

export const TitleQuarantine = {
  list: "Quarantine List",
  edit: "Edit Quarantine",
  create: "Create Quarantine",
};

export const WebSuiteChoices = [
  { id: false, name: "No Web Suite Reference" },
  { id: true, name: "Web Suite Reference" },
];
